import React, {useEffect, useState} from "react";
import { motion, AnimatePresence } from "framer-motion";
import { industrialMinerals } from "../Data";
import BreadCrumb from "../Components/BreadCrumb";
import bgImg from '../Images/industrial-breadcrumb.webp';
import organizationSchema from "../Schema/OrganizationSchema";
import SchemaMarkup from "../Components/SchemaMarkup";
import breadcrumbSchema from "../Schema/BreadcrumbSchema";
import collectionPageSchema from "../Schema/CollectionPageSchema";
import itemListSchema from "../Schema/ItemListSchema";

const IndustrialCommon=()=>{
   const [selectedCard, setSelectedCard] = useState(null);

    useEffect(() => {
                document.title =
                  "Industrial Minerals Products | Iris Impulse India Pvt. Ltd.";
            
                const metaDesc = document.querySelector("meta[name='description']");
                if (metaDesc) {
                  metaDesc.setAttribute(
                    "content",
                    "Explore Iris Impulse India Pvt. Ltd.'s premium industrial minerals, including attapulgite, barites, kaolin, talc, silica, bleach clay, laterite, & fly ash. Contact now!"
                  );
                }
            
                 const canonical = document.querySelector("link[rel='canonical']");
              if (canonical) {
                canonical.setAttribute("href", "https://irisimpulse.com/industrial-minerals");
              }
            
              const ogTitle = document.querySelector("meta[property='og:title']");
              if (ogTitle) {
                ogTitle.setAttribute(
                  "content",
                  "Industrial Minerals Products | Iris Impulse India Pvt. Ltd."
                );
              }
            
                const ogDesc = document.querySelector("meta[property='og:description']");
              if (ogDesc) {
                ogDesc.setAttribute(
                  "content",
                  "Explore Iris Impulse India Pvt. Ltd.'s premium industrial minerals, including attapulgite, barites, kaolin, talc, silica, bleach clay, laterite, & fly ash. Contact now!"
                );
              }
            
              const ogUrl = document.querySelector("meta[property='og:url']");
              if (ogUrl) {
                ogUrl.setAttribute("content", "https://irisimpulse.com/industrial-minerals");
              }
            
                const ogImage = document.querySelector("meta[property='og:image']");
              if (ogImage) {
                ogImage.setAttribute(
                  "content",
                  "https://irisimpulse.com/Images/industrial.webp"
                );
              }
            
                const twitterTitle = document.querySelector("meta[name='twitter:title']");
              if (twitterTitle) {
                twitterTitle.setAttribute(
                  "content",
                  "Industrial Minerals Products | Iris Impulse India Pvt. Ltd."
                );
              }
            
                const twitterDesc = document.querySelector(
                "meta[name='twitter:description']"
              );
              if (twitterDesc) {
                twitterDesc.setAttribute(
                  "content",
                  "Explore Iris Impulse India Pvt. Ltd.'s premium industrial minerals, including attapulgite, barites, kaolin, talc, silica, bleach clay, laterite, & fly ash. Contact now!"
                );
              }
            
                const twitterImage = document.querySelector("meta[name='twitter:image']");
              if (twitterImage) {
                twitterImage.setAttribute(
                  "content",
                  "https://irisimpulse.com/Images/industrial.webp"
                );
              }
              }, []);

  const container = {
    hidden: {},
    visible: {
      transition: {
        staggerChildren: 0.15
      }
    }
  };

  const fadeUp = {
    hidden: { opacity: 0, y: 40 },
    visible: {
      opacity: 1,
      y: 0,
      transition: { duration: 0.8, ease: "easeOut" }
    }
  };

  const cardAnim = {
    hidden: { opacity: 0, y: 50 },
    visible: {
      opacity: 1,
      y: 0,
      transition: { duration: 0.7, ease: "easeOut" }
    }
  };

  const organizationData = organizationSchema();
  const breadcrumbData = breadcrumbSchema({
  items: [
    {
      name: "Home",
      url: "https://irisimpulse.com/",
    },
    {
      name: "Industrial Minerals",
    },
  ],
});
const industrialCollectionData = collectionPageSchema({
  url: "https://irisimpulse.com/industrial-minerals",
  title: "Industrial Minerals Products | Iris Impulse India Pvt. Ltd.",
  description:"Explore Iris Impulse India Pvt. Ltd.'s premium industrial minerals, including attapulgite, barites, kaolin, talc, silica, bleach clay, laterite, & fly ash. Contact now!",
  image: "https://irisimpulse.com/Images/industrial.webp",

  items: [
    {
      name: "Attapulgite Clay",
      url: "https://irisimpulse.com/industrial-minerals/attapulgite-clay",
    },
    {
      name: "Iris Bleach Clay",
      url: "https://irisimpulse.com/industrial-minerals/iris-bleach-clay",
    },
    {
      name: "Kaolin Clay",
      url: "https://irisimpulse.com/industrial-minerals/kaolin-clay",
    },
    {
      name: "Laterite",
      url: "https://irisimpulse.com/industrial-minerals/laterite-mineral",
    },
    {
      name: "Talc",
      url: "https://irisimpulse.com/industrial-minerals/talc-mineral",
    },
  ],
});
const industrialItemsData = itemListSchema({
  name: "Industrial Minerals Products | Iris Impulse India Pvt. Ltd.",
  description:"Explore Iris Impulse India Pvt. Ltd.'s premium industrial minerals, including attapulgite, barites, kaolin, talc, silica, bleach clay, laterite, & fly ash. Contact now!",
  url: "https://irisimpulse.com/industrial-minerals",

  items: [
    {
      name: "Attapulgite Clay",
      url: "https://irisimpulse.com/industrial-minerals/attapulgite-clay",
      image: "https://irisimpulse.com/Images/attapulgite.webp",
    },
    {
      name: "Iris Bleach Clay",
      url: "https://irisimpulse.com/industrial-minerals/iris-bleach-clay",
      image: "https://irisimpulse.com/Images/iris-bleach-clay.webp",
    },
    {
      name: "Kaolin Clay",
      url: "https://irisimpulse.com/industrial-minerals/kaolin-clay",
      image: "https://irisimpulse.com/Images/kaolin.webp",
    },
    {
      name: "Laterite",
      url: "https://irisimpulse.com/industrial-minerals/laterite-mineral",
      image: "https://irisimpulse.com/Images/laterite.webp",
    },
    {
      name: "Talc",
      url: "https://irisimpulse.com/industrial-minerals/talc-mineral",
      image: "/Images/talc.webp",
    },
  ]
});
    return(
        <>

        <SchemaMarkup data={organizationData} /> 
        <SchemaMarkup data={breadcrumbData} />
        <SchemaMarkup data={industrialCollectionData} />
        <SchemaMarkup data={industrialItemsData} />
          <BreadCrumb
  title="Industrial Minerals" 
  bgImage={bgImg} 
/>

<div className="bg-section bentonite-sec">
       <section className="card-section container">
            
            {/* HEADING */}
            <motion.h2
              className="section-heading"
              variants={fadeUp}
              initial="hidden"
              whileInView="visible"
              viewport={{ once: true }}
            >
              Industrial Mineral Products for Manufacturing & Industrial Sectors
            </motion.h2>
      
            {/* CARDS */}
            <motion.div
              className="cards-grid"
        variants={container}
        initial="hidden"
        animate="visible"
            >
             {industrialMinerals.map((card) => (
                <motion.div
                  key={card.id}
                  className="card"
                  variants={cardAnim}
                  whileHover={{ y: -8 }}
                  whileTap={{ scale: 0.98 }}
                  onClick={() => setSelectedCard(card)}
                >
                  <div className="card-content">
                    
                    {/* IMAGE */}
                    <div className="image-wrapper">
                      <motion.img
                        src={card.img}
                        alt={`${card.title} | Iris Impulse India Pvt. Ltd.`}
                        className="card-image"
                        whileHover={{ scale: 1.05 }}
                        transition={{ duration: 0.5 }}
                      />
                    </div>
      
                    <h3>{card.cardTitle}</h3>
                    <p>{card.cardDescription}</p>
                  </div>
                </motion.div>
              ))}
            </motion.div>
      
            {/* MODAL */}
            <AnimatePresence>
              {selectedCard && (
                <motion.div
                  className="modal-overlay"
                  onClick={() => setSelectedCard(null)}
                  initial={{ opacity: 0 }}
                  animate={{ opacity: 1 }}
                  exit={{ opacity: 0 }}
                  transition={{ duration: 0.3 }}
                >
            <motion.div
        className="modal-content"
        onClick={(e) => e.stopPropagation()}
        initial={{ opacity: 0, scale: 0.9, y: 40 }}
        animate={{ opacity: 1, scale: 1, y: 0 }}
        exit={{ opacity: 0, scale: 0.9, y: 40 }}
        transition={{ duration: 0.4, ease: "easeOut" }}
      >
        
        {/* CLOSE BUTTON */}
        <div className="modal-header">
        <button className="modal-close"
         onClick={(e) => {
          e.stopPropagation();   
          setSelectedCard(null); 
        }}>×</button>
      </div>
      
        <img src={selectedCard.largeImg} alt={`${selectedCard.cardDescriptione} | Iris Impulse India Pvt. Ltd.`} />
        <h3>{selectedCard.cardTitle}</h3>
        <h4>{selectedCard.cardDescription}</h4>
        <p className="section-text">{selectedCard.introPara}</p>
      
        <motion.a
        href={`/industrial-minerals/${selectedCard.url}`}
          className="outline-btn"
          whileHover={{ scale: 1.05 }}
          whileTap={{ scale: 0.97 }}
        >
          LEARN MORE
        </motion.a>
      
      </motion.div>
                </motion.div>
              )}
            </AnimatePresence>
      
          </section>
          </div>
          <div style={{marginBottom:"-80px"}}></div>
        </>
    )
}
export default IndustrialCommon;